import rootReducer from '../reducers';
import thunk from 'redux-thunk';
import {applyMiddleware, compose, createStore} from 'redux';
import createLogger from 'redux-logger';
import { browserHistory } from 'react-router'
import { routerMiddleware } from 'react-router-redux'
//import DevTools from '../containers/DevTools';

export default function configureStore(initialState) {
    let createStoreWithMiddleware;

    const router = routerMiddleware(browserHistory);
    //const logger = createLogger();

    const middleware = applyMiddleware(thunk, router);

    createStoreWithMiddleware = compose(
		middleware,
		//DevTools.instrument()
    );

    const store = createStoreWithMiddleware(createStore)(rootReducer, initialState);

    return store;

}


/** WEBPACK FOOTER **
 ** ./js/store/configureStore.js
 **/